<template>
  <section>
    <!-- Introduction -->
    <v-row>
      <v-col cols="12">
        <p>
          Bolivia, before being colonized by the Spanish, was part on the Inca empire. You can see tarces of that history a little bit everywhere in the west part country. If you want to be sure to see some Inca architectures, go to the Isla del Sol on the Titicaca lake! 
          This country also offers a diversiy in landscape, from dense forest to white montain, salt lakes and colorful markets, you will have enough for your eyes and memories.
        </p>
        <p>
          I went to Bolivia with my brother in 2014, on a 3 weeks trips. It was an intense journey filled with great memories! I hope the photos taken will give you the motivation to go there.
        </p>
      </v-col>
    </v-row>
    <!-- Gallery -->
    <v-row>
      <v-col cols="12">
        <PortfolioGallery :img="list" />
      </v-col>
    </v-row>
  </section>
</template>

<script>
export default {
  data: () => {
    return {
      list: [
        {
          link: "/img/photos/Bolivia/coucher soleil Titicaca.jpg",
          title: "Sunset over Titicaca",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Highway to heaven.jpg",
          title: "Highway to heaven",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Inca's way.jpg",
          title: "Inca's way",
          description: null
        },
        {
          link: "/img/photos/Bolivia/jungle vue de l'eau.jpg",
          title: "Jungle's gate",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Mirage mirage.jpg",
          title: "Mirage mirage",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Play ground of steel.jpg",
          title: "Playground of steel",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Rising of the eye.jpg",
          title: "Rise of the eye",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Road of steel.jpg",
          title: "Road of steel",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Sunset over the Pampa.jpg",
          title: "Sunset over the pampa",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Titicaca.jpg",
          title: "Welcome to Titicaca",
          description: null
        },
        {
          link: "/img/photos/Bolivia/Train rust.jpg",
          title: "Train and rust",
          description: null
        },
        {
          link: "/img/photos/Bolivia/White is not always snow.jpg",
          title: "White is not always snow",
          description: null
        },
      ]
    };
  },

  created() {
    this.$store.commit('SET_GALLERY_DATA', this.list)
  }
};
</script>

<style></style>
